import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartLineUpDown, faChartLineDown, faThumbsUp } from '@fortawesome/pro-light-svg-icons'
import { Colors, TextV2 as Text, Flex, Box } from '@pinchenterprisesnpm/friday-ui'

interface IPayRateFeedbackProps {
  payValue: number
  suggestedPayRate: number
}

export const PayRateFeedback = ({ payValue, suggestedPayRate }: IPayRateFeedbackProps) => {
  const difference = payValue - suggestedPayRate
  const percentageDifference = (difference / suggestedPayRate) * 100

  if (!suggestedPayRate) {
    return null
  }

  if (percentageDifference <= -10) {
    return (
      <Box mb='sm' mt='sm'>
        <Flex style={{ color: Colors.danger }} flexDirection='row'>
          <Text fontSize='small' color='red.300' fontWeight='regular'>
            <FontAwesomeIcon
              icon={faChartLineDown}
              size='lg'
              style={{ color: Colors.danger, marginRight: 6 }}
            />
            Low Pay – Well below market (${suggestedPayRate}). May delay fills.
          </Text>
        </Flex>
      </Box>
    )
  } else if (percentageDifference < 0) {
    return (
      <Box mb='sm' mt='sm'>
        <Flex style={{ color: Colors.warning }} flexDirection='row'>
          <Text fontSize='small' color='orange.300' fontWeight='regular'>
            <FontAwesomeIcon
              icon={faChartLineUpDown}
              size='lg'
              style={{ color: Colors.warning, marginRight: 6 }}
            />
            Below Market – Slightly under ${suggestedPayRate}. Consider raising.
          </Text>
        </Flex>
      </Box>
    )
  } else {
    return (
      <Box mb='sm' mt='sm'>
        <>
          <Flex style={{ color: Colors.success }}>
            <Text fontSize='small' color='green.300' fontWeight='regular'>
              <FontAwesomeIcon
                icon={faThumbsUp}
                size='lg'
                style={{ marginRight: 6, color: Colors.success }}
              />
              Good Rate – Competitive pay for fast fills.
            </Text>
          </Flex>
        </>
      </Box>
    )
  }
}
